import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { BsFillFileEarmarkPlusFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import { PaymentStrings } from "../../../../business/core";
import { PaymentOrdersPageControllerImpl } from "../../../../business/impl";

interface IStrategyButtonBankSlipCreate {
    id: string;
}

export const StrategyButtonBankSlipCreate: React.FC<IStrategyButtonBankSlipCreate> = ({ id }) => {
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [dueDate, setDueDate] = useState<string>('');
    const [ourNumber, setOurNumber] = useState<string>('');
    const [barcode, setBarcode] = useState<string>('');
    const [errorRequest, setErrorRequest] = useState<string>('');
    const translate = PaymentStrings['PTBR'].payment_order;
    const [selectedFile, setSelectedFile] = useState<any>([]);
    const handlerCreateBankSlip = async () => {
        setLoading(true);

        const formData = new FormData();
        formData.append("payment_order", id);
        formData.append("due_date", dueDate);
        formData.append("barcode", barcode);
        formData.append("our_number", ourNumber);
        formData.append(`file`, selectedFile[0]);

        const controller = new PaymentOrdersPageControllerImpl();
        try {
            const response = await controller.createBankInvoice(formData);
            if (!response.success) {
                let errorMessage = response.response.toString();
                if (translate.errors[response.response.toString()]) {
                    errorMessage = translate.errors[response.response.toString()];
                }
                setErrorRequest(errorMessage);
                setLoading(false);
                return false;
            }

            let successMessage = response.response.toString();
            if (translate.success[response.response.toString()]) {
                successMessage = translate.success[response.response.toString()];
            }

            localStorage.setItem('global-toast', JSON.stringify({ type: 'success', message: successMessage }));
            window.location.reload();
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/paymentOrder',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                console.error("Erro na requisição:", error);
            }
        }
        setLoading(false);
    }

    const RequiredFieldMark = (): React.ReactElement => {
        return <span style={{ fontWeight: 'bold', color: 'red' }}>*</span>
    }

    const handleFileChange = (e) => {
        const bankSlipFile: Array<any> = Array.from(e.target.files);
        setSelectedFile(bankSlipFile);
    };

    return (
        <>
            <Button
                onClick={() => setShowModal(true)}>
                {
                    <>
                        <BsFillFileEarmarkPlusFill className="me-2 mb-1" />{translate.strategy_buttons.create_bank_slip_button_label}
                    </>
                }
            </Button>

            <Modal show={showModal} onHide={() => !isLoading ? setShowModal(false) : null}>
                <Modal.Header closeButton>
                    <Modal.Title>{translate.strategy_buttons.create_bank_slip_button_label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="mt-4">
                        <Form.Group className="mb-3" controlId="dueDate">
                            <Form.Label>{translate.strategy_buttons.due_date_input_label} <RequiredFieldMark /></Form.Label>
                            <Form.Control type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} autoComplete="off" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="ourNumber">
                            <Form.Label>{translate.strategy_buttons.our_number_input_label} <RequiredFieldMark /></Form.Label>
                            <Form.Control type="tel" value={ourNumber} onChange={(e) => setOurNumber(e.target.value)} autoComplete="off" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="barcode">
                            <Form.Label>{translate.strategy_buttons.barcode_input_label} <RequiredFieldMark /></Form.Label>
                            <Form.Control type="tel" value={barcode} onChange={(e) => setBarcode(e.target.value)} autoComplete="off" />
                        </Form.Group>
                        <Form.Group controlId="formFileMultiple" className="mb-3">
                            <Form.Label>{translate.strategy_buttons.barcode_input_label}</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".pdf"
                                multiple
                                required
                                onChange={handleFileChange}
                            />
                        </Form.Group>
                        <Form.Text id="passwordHelpBlock" style={{ color: 'red' }}>
                            {errorRequest}
                        </Form.Text>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isLoading}>{translate.strategy_buttons.modal.button_cancel}</Button>
                    <Button variant="primary" onClick={() => handlerCreateBankSlip()} disabled={isLoading}>{translate.strategy_buttons.modal.button_forward}</Button>
                </Modal.Footer>
            </Modal >
        </>
    )
}